<template>
    <div class="star-rating-display d-inline-flex align-center">
        <span
            v-if="showValue"
            class="mr-2 font-weight-bold"
            :style="numericScoreStyle"
        >{{ formattedNumericScore }}{{ valueSuffix }}</span>
        <Vue3StarRatings
            :model-value="scoreForStarBar"
            :number-of-stars="5"
            :star-size="starSize"
            :star-color="starColor"
            :inactive-color="inactiveColor"
            :disable-click="true"
        />
    </div>
</template>

<script>
export default {
    name: "StarRatingDisplay",
    props: {
        modelValue: { type: Number, default: 0 },
        /** Show numeric score (with decimals) before the stars */
        showValue: { type: Boolean, default: false },
        decimals: { type: Number, default: 2 },
        valueSuffix: { type: String, default: "" },
        valueTextColor: { type: String, default: "#000000" },
        starSize: { type: Number, default: 20 },
        starColor: { type: String, default: "#ffeb3b" },
        inactiveColor: { type: String, default: "#9e9e9e" },
    },
    computed: {
        /** Value passed to the star strip (0–5); keeps the fill aligned with the displayed average. */
        scoreForStarBar() {
            const raw = Number(this.modelValue);
            if (Number.isNaN(raw) || raw < 0) return 0;
            return Math.min(5, raw);
        },
        formattedNumericScore() {
            const raw = Number(this.modelValue);
            if (Number.isNaN(raw)) return "";
            return raw.toFixed(this.decimals);
        },
        numericScoreStyle() {
            return { color: this.valueTextColor };
        },
    },
};
</script>

<style scoped>
.star-rating-display {
    flex-shrink: 0;
}
</style>
